export function signUp (entryPoint) {
  return (dispatch, getState, { clientEventManager }) => {
    const eventProps = {
      entry_point: entryPoint,
    }
    clientEventManager.logEvent('login_tapped', eventProps)
  }
}

export function logIn (entryPoint) {
  return (dispatch, getState, { clientEventManager }) => {
    const eventProps = {
      entry_point: entryPoint,
    }
    clientEventManager.logEvent('login_tapped', eventProps)
  }
}
